// Drag-to-scroll for horizontal sliders (featured collection, slideshow) on desktop.
// Skipped on touch devices — native pan already handles it.
(function () {
  if (typeof window === 'undefined') return;
  // Touch device → bail (native horizontal swipe works)
  if (window.matchMedia('(pointer: coarse)').matches) return;

  const DRAG_THRESHOLD = 5; // px before we treat mousedown as drag (not click)
  const SCROLL_MULT = 1.5;   // multiplier for "feels right" drag distance → scroll

  function attach(scroller) {
    if (!scroller || scroller.dataset.dragScrollAttached === '1') return;
    scroller.dataset.dragScrollAttached = '1';

    let isDown = false;
    let didDrag = false;
    let startX = 0;
    let startScrollLeft = 0;

    // Make the cursor signal that it's draggable
    scroller.style.cursor = 'grab';

    scroller.addEventListener('mousedown', (e) => {
      // Only primary button; skip if clicking on form control / interactive nested element
      if (e.button !== 0) return;
      const tag = e.target.tagName;
      if (tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return;

      isDown = true;
      didDrag = false;
      startX = e.pageX;
      startScrollLeft = scroller.scrollLeft;
      scroller.style.cursor = 'grabbing';
      scroller.style.userSelect = 'none';
    });

    // Use window-level mousemove/mouseup so drag continues if cursor leaves the element
    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
      }
      if (didDrag) {
        e.preventDefault();
        scroller.scrollLeft = startScrollLeft - dx * SCROLL_MULT;
      }
    }, { passive: false });

    window.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      scroller.style.cursor = 'grab';
      scroller.style.userSelect = '';

      if (didDrag) {
        // Suppress the click that fires after mouseup, so card links don't navigate
        const suppress = (e) => {
          e.preventDefault();
          e.stopPropagation();
        };
        scroller.addEventListener('click', suppress, { capture: true, once: true });
        // Safety net: clear the suppressor in case no click happens
        setTimeout(() => {
          scroller.removeEventListener('click', suppress, { capture: true });
        }, 100);
      }
    });

    // Prevent drag-and-drop on images inside the scroller from interfering
    scroller.querySelectorAll('img, a').forEach((el) => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  function attachAll() {
    document.querySelectorAll('slider-component .slider, slideshow-component .slider, slideshow-component .slideshow').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }

  // Re-attach if Shopify section reloads (theme editor / section rendering API)
  document.addEventListener('shopify:section:load', attachAll);
  // Also retry once 1s later to catch late-mounted custom elements
  setTimeout(attachAll, 1000);
})();
